import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Auth0MetaData } from "./Auth0MetaData";
import { Domains } from '../Utils';

export const Auth0ProviderWithNavigate = ({children}: {children: React.ReactNode}) =>
{
	const navigate = useNavigate();

	const domain = process.env.REACT_APP_AUTH0_DOMAIN;
	const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
      
	const onRedirectCallback = async (appState: any) => {
		navigate(appState?.returnTo || window.location.pathname);
	};

	if (!(domain && clientId && Domains.redirectURL)) {
		return null;
	}
	 
	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			authorizationParams={{
				redirect_uri: Domains.redirectURL,
				audience: Domains.apiAudience,
//				scope: "openid profile email read:pck write:lsl"
				scope: "openid profile email"
			}}
			onRedirectCallback={onRedirectCallback}
		>
			<Auth0MetaData>
				{children}
			</Auth0MetaData>
		</Auth0Provider>
	);
};

